import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Appointment } from "models";

const component = "NavBarSearch";

export const NavBarSearchKeys = {
  searchTerm: localQueryKey<string>({ component, data: "searchTerm" }),
  claireAppointmentSearchResults: backendQueryKey<Appointment[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/appointments/search" }),
  dmsAppointmentSearchResults: backendQueryKey<Appointment[]>({ component, baseUrl: ENV.dmsAccessorBaseURL, endpoint: "/appointments/search" })
};
